export interface IExpertSystemWaitTimes {
    recipientId: number; 
    totalAbocDonorsInLastYear: number;  
    estimatedAbocDonorsPerMonth: number;  
    totalAbocDonorsWith3gTyping: number;
    countEpletMmNone: number;
    countEpletMmLow: number;
    countEpletMmIntermediate: number;
    countEpletMmHigh: number;
    cpraEpletMmNone: number;
    cpraEpletMmLow: number;
    cpraEpletMmIntermediate: number;
    donorsNeededMmNone: number;
    donorsNeededMmLow: number;
    donorsNeededMmIntermediate: number;
    estimatedWaitMmIntermediate: number;
    estimatedWaitMmLow: number;
    estimatedWaitMmNone: number;
}
